"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const createPlaceholder = placeholder => placeholder ? `data:image/webp;base64, ${placeholder}` : undefined;
var _default = exports.default = createPlaceholder;